angular.module('ikeweb.spike.sharing').controller('MeasureViewController', [
    '$scope',
    '$rootElement',
    '$stateParams',
    'measurementService',
    'captureSharingService',
    '$location',
    'printService',
    'captureExportService',
    'loginService',

    function($scope, $rootElement, $stateParams, measurementService, captureSharingService, $location, printService, captureExportService, loginService) {
        var sharedCaptureId = $stateParams.sharedCaptureId;

        var ERROR_PATH = '/error/sharedCaptureNotFound';

        function redirectToErrorPage() {
            $location.path(ERROR_PATH);
        }

        if (!sharedCaptureId) {
            redirectToErrorPage();
        }

        function createImage(captureImage) {
            var image = document.createElement('img');
            image.src = URL.createObjectURL(captureImage.getData());
            return image;
        }

        function displayImage(image) {
            $rootElement.find('.pages-measureview-exportImageWrapper')
                .append(image);
        }

        captureSharingService.getSharedCapture(sharedCaptureId)
            .then(function(sharedCapture) {
                $scope.sharedCapture = sharedCapture;
                $scope.sharedMeasurements = measurementService.createMeasurementsFromStorage(sharedCapture.measurements);
                $scope.sharedNote = sharedCapture.note;
                return captureExportService.imageWithMeasurements(sharedCapture, sharedCapture.getZoomArea());
            }, redirectToErrorPage)
            .then(createImage)
            .then(displayImage);

        function print() {
            printService.printElement($rootElement.find('.pages-measureview-report-page'));
        }

        function canImportSharedCapture() {
            return loginService.isLoggedIn();
        }

        this.print = print;
        this.canImportSharedCapture = canImportSharedCapture;
        this.importSharedCapture = captureSharingService.importSharedCapture;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/sharing/measure.view.controller.js
// module id = 596
// module chunks = 0